export const css = (el: HTMLElement, styles: Object = {}): unknown => Object.assign(el.style, styles);

// Covers the following:
// isObjectEmpty(null)              => true
// isObjectEmpty(undefined)         => true
// isObjectEmpty({})                => true
// isObjectEmpty({ name: 'Bob' })   => false
export const isObjectEmpty = (targetObject?: Record<string, unknown> | null): boolean => {
  return !targetObject || Object.keys(targetObject).length === 0;
};

export const include = (item: string, value: string): boolean => {
  return item.toString().toLowerCase().includes(value.toLowerCase());
};

export const search = (inputValue: string, arr: any, key?: string): any[] => {
  let result: any[] = [];
  if (key) result = arr.filter((list: any) => include(list[key], inputValue));
  else result = arr.filter((list: any) => include(list, inputValue));
  return result;
};

export const searchSome = (inputValue: string, arr: any, keys: Array<Array<string> | string>): any[] => {
  const result: any[] = [];
  arr.map((list: any) => {
    let can: boolean = false;
    keys.map((key) => {
      if (typeof key === 'string') {
        if (include(list[key], inputValue)) can = true;
        return;
      }
      const [first, second, third] = key;

      if (list[first][second]) {
        if (inputValue.split(' ').length > 1 && list[first][third]) {
          const [name, surname] = inputValue.split(' ');
          if (
            (include(list[first][second], name) && include(list[first][third], surname)) ||
            (include(list[first][third], name) && include(list[first][second], surname))
          )
            can = true;
          return;
        }

        if (include(list[first][second], inputValue)) can = true;
      }
    });
    can && result.push(list);
  });
  return result;
};

export const processPhoneNumber = (phoneNumber: any) => {
  const regExp = /(\s)|(\(|\))|(-)/g;
  return phoneNumber.replaceAll(regExp, '');
};

export const processDate = (date: string) => {
  const separator = /\.|\/|\s/g;
  const [month, day, year] = new Date(date)
    .toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })
    .split(separator);
  return `${month} ${day} ${year}`;
};

const transformToAssocArray = (prmstr: string) => {
  const params: any = {};
  const prmarr: string[] = prmstr.split('&');
  for (let i = 0; i < prmarr.length; i++) {
    let tmparr = prmarr[i].split('=');
    params[tmparr[0]] = tmparr[1];
  }
  return params;
};

export const getSearchParameters = () => {
  const prmstr = window.location.search.substr(1);
  return prmstr != null && prmstr != '' ? transformToAssocArray(prmstr) : {};
};

export const getCookie = (cookieName: string): string | boolean => {
  let cookie;
  const cookiesArray = document.cookie.split(';');
  cookiesArray.forEach((item) => {
    if (item.includes(cookieName)) {
      cookie = item.split('=')[1];
    }
  });
  return cookie || false;
};

export const random = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min
};

export const debounce = (fn: (args: any) => void, ms: number) => {
  let timeout: NodeJS.Timeout;

  return function <A>(...args: [A]) {
    clearTimeout(timeout);
    // @ts-ignore
    timeout = setTimeout(() => fn.apply(this, args), ms);
  };
};

export const makeId = (length = 3): string => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) result += characters.charAt(Math.floor(Math.random() * charactersLength));
  return result;
};
